import { IQuickAction } from './quick-action.component';
import { Session } from '@services/session';
import { isDesktopView } from '@lib/screen-sizes';

export const QUICK_ACTIONS_ICONS: {[key: string]: string} = {
  fuelPurchases: require('../../images/fleet-view/sidebar/receipt.svg'),
  geofences: require('../../images/fleet-view/sidebar/geofence.svg'),
  drivers: require('../../images/fleet-view/sidebar/driver.svg'),
  vehicles: require('../../images/fleet-view/sidebar/vehicle.svg'),
  assets: require('../../images/fleet-view/sidebar/trailer.svg'),
};

export const QUICK_ACTIONS: IQuickAction[] = [
  {
    link: (session: Session) => '/ifta/fuel-purchases/add',
    label: $localize`Upload Fuel Purchase`,
    name: 'fuelPurchases',
    shouldShowQuickAction: (session: Session) => session.userPermissions.isFuelPurchaseManage(),
  },
  {
    link: (session: Session) => '/fleetview/geofences/new',
    label: $localize`Create Geofence`,
    name: 'geofences',
    shouldShowQuickAction: (session: Session) => session.userPermissions.isGeofenceManageAllowed()
      && session.hasCompanyGeofenceEnabled() && isDesktopView()
    ,
  },
  {
    link: (session: Session) => 'admin/drivers/new',
    label: $localize`Add Driver`,
    name: 'drivers',
    shouldShowQuickAction: (session: Session) => session.userPermissions.isDriversManageAllowed(),
  },
  {
    link: (session: Session) => 'admin/vehicles/new',
    label: $localize`Add Vehicle`,
    name: 'vehicles',
    shouldShowQuickAction: (session: Session) => session.userPermissions.isVehiclesManageAllowed(),
  },
  {
    link: (session: Session) => 'admin/assets/new',
    label: $localize`Add Asset`,
    name: 'assets',
    shouldShowQuickAction: (session: Session) => session.userPermissions.isAssetsManageAllowed(),
  },
];
